<span>{{ message | translate }}</span>
@if (steps > 0) {
  <span> {{ 'uix.components.progress.step' | translate }} {{ progress }} / {{ steps }}</span>
}
@if (steps > 0) {
  <mat-progress-bar mode="determinate" [value]="(progress / steps) * 100"></mat-progress-bar>
}
